export default "__VITE_PUBLIC_ASSET__64b2e8d1__"